import { useFileFilter, useSetFileFilter } from '@gripp/shared-logic';
import {
  countFilters,
  FilesSearchInput,
  FilterHeaders,
  SlideAction,
  useSlideLayout,
  ViewMode,
} from '@gripp/shared-ui';
import { StyleSheet, View } from 'react-native';
import { useNavigate } from 'react-router-dom';
import { CreateFileHeaderButton } from './createFileHeaderButton';

export const FilesFilters = () => {
  const navigate = useNavigate();
  const { currentViewMode, onSlideChange } = useSlideLayout();

  const { data: fileFilter } = useFileFilter();
  const { mutateAsync: setFileFilter } = useSetFileFilter();
  const filterCount = countFilters(fileFilter);

  const onFilterNavigate = async () => {
    if (currentViewMode === ViewMode.SINGLE) {
      await onSlideChange(SlideAction.DUAL);
    }
    navigate('/files/filters');
  };

  return (
    <View style={styles.filtersContainer}>
      <FilterHeaders
        currentSearchKeyword={fileFilter?.keyword}
        searchComponent={<FilesSearchInput />}
        onFilterPress={onFilterNavigate}
        onSearchClose={() => setFileFilter({ keyword: '' })}
        filterCount={filterCount}
        Routes={{}}
      />

      <CreateFileHeaderButton />
    </View>
  );
};

const styles = StyleSheet.create({
  filtersContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: 12,
  },
});
